import axios from '@/lib/api/axios'

export async function getBillingDetails(authContext) {
  const { data: billing } = await axios(
    `/organization/${authContext.user.organization.id}`,
    { method: 'GET' },
    authContext,
    true, // Set Content-Type
    'billing', // Use Billing URL
  )
  return billing
}
